/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterBookableScheduleException } from './ClaimCenterBookableScheduleException';
import {
    ClaimCenterBookableScheduleExceptionFromJSON,
    ClaimCenterBookableScheduleExceptionFromJSONTyped,
    ClaimCenterBookableScheduleExceptionToJSON,
} from './ClaimCenterBookableScheduleException';
import type { ClaimCenterScheduleException } from './ClaimCenterScheduleException';
import {
    ClaimCenterScheduleExceptionFromJSON,
    ClaimCenterScheduleExceptionFromJSONTyped,
    ClaimCenterScheduleExceptionToJSON,
} from './ClaimCenterScheduleException';

/**
 * 
 * @export
 * @interface ClaimCenterScheduleExceptions
 */
export interface ClaimCenterScheduleExceptions {
    /**
     * 
     * @type {Array<ClaimCenterBookableScheduleException>}
     * @memberof ClaimCenterScheduleExceptions
     */
    bookableExceptions: Array<ClaimCenterBookableScheduleException>;
    /**
     * 
     * @type {Array<ClaimCenterScheduleException>}
     * @memberof ClaimCenterScheduleExceptions
     */
    claimCenterExceptions: Array<ClaimCenterScheduleException>;
}

/**
 * Check if a given object implements the ClaimCenterScheduleExceptions interface.
 */
export function instanceOfClaimCenterScheduleExceptions(value: object): value is ClaimCenterScheduleExceptions {
    if (!('bookableExceptions' in value) || value['bookableExceptions'] === undefined) return false;
    if (!('claimCenterExceptions' in value) || value['claimCenterExceptions'] === undefined) return false;
    return true;
}

export function ClaimCenterScheduleExceptionsFromJSON(json: any): ClaimCenterScheduleExceptions {
    return ClaimCenterScheduleExceptionsFromJSONTyped(json, false);
}

export function ClaimCenterScheduleExceptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterScheduleExceptions {
    if (json == null) {
        return json;
    }
    return {
        
        'bookableExceptions': ((json['bookableExceptions'] as Array<any>).map(ClaimCenterBookableScheduleExceptionFromJSON)),
        'claimCenterExceptions': ((json['claimCenterExceptions'] as Array<any>).map(ClaimCenterScheduleExceptionFromJSON)),
    };
}

export function ClaimCenterScheduleExceptionsToJSON(value?: ClaimCenterScheduleExceptions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'bookableExceptions': ((value['bookableExceptions'] as Array<any>).map(ClaimCenterBookableScheduleExceptionToJSON)),
        'claimCenterExceptions': ((value['claimCenterExceptions'] as Array<any>).map(ClaimCenterScheduleExceptionToJSON)),
    };
}

